export const stringToNumber = (str) => {
  if (typeof str === 'string') {
    str = str.replace(',', '.');
    str = str.replace(' ', '');
  }

  return Number(str);
};
